import { render, staticRenderFns } from "./BotNameAndToLink.vue?vue&type=template&id=7da8e776&"
import script from "./BotNameAndToLink.vue?vue&type=script&lang=js&"
export * from "./BotNameAndToLink.vue?vue&type=script&lang=js&"
import style0 from "./BotNameAndToLink.vue?vue&type=style&index=0&id=7da8e776&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports